import React from 'react';
import {Image, Platform, ScrollView, Text, View} from 'react-native';
import {getFullImageUrl} from '../../../common/utils/image';
import globalStyle from '../../styles/globalStyle';
import {styles} from './styles';

type Props = {
  description?: string;
  srcImage: string;
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSouscrire: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleDemande: any;
};

export function DetailDemarcheItem({
  description,
  title,
  srcImage,
  handleSouscrire,
  handleDemande,
}: Props) {
  return (
    <ScrollView
      contentContainerStyle={
        Platform.OS === 'web' ? {} : {flexGrow: 1, backgroundColor: '#ffffff'}
      }>
      <View
        style={
          Platform.OS === 'web'
            ? [globalStyle.containerFluid, {width: '100%'}]
            : {flexGrow: 1}
        }>
        <View testID={description} style={styles.alignMenu}>
          <View style={styles.alignImage}>
            <Image
              resizeMode="contain"
              style={styles.detailImage}
              source={{
                uri: getFullImageUrl(srcImage),
              }}></Image>
          </View>
          <View style={styles.descriptionContainer}>
            <View style={styles.contentBody}>
              <Text style={[globalStyle.titlePrimaryH2, styles.title]}>
                {title}
              </Text>
              <Text style={styles.descriptionText}>{description}</Text>
              {handleSouscrire && handleSouscrire != null ? (
                <Text
                  onPress={() => handleSouscrire()}
                  style={[globalStyle.link, styles.link]}>
                  Souscrire ici!
                </Text>
              ) : null}
              {handleDemande && handleDemande != null ? (
                <Text
                  onPress={() => handleDemande()}
                  style={[globalStyle.link, styles.link]}>
                  Demander une simulation
                </Text>
              ) : null}
            </View>
          </View>
        </View>
      </View>
    </ScrollView>
  );
}
